/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Tab_Cancel_SubscriptionInputs */



/**
* | output |
* | --- |
* | "Cancel Subscription" |
*
* @param {Plan_Tab_Cancel_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_cancel_subscription = /** @type {((inputs?: Plan_Tab_Cancel_SubscriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Cancel_SubscriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement kündigen")
	return /** @type {LocalizedString} */ ("Cancel Subscription")
});